export const create = {
  createSuccessfully: '新しい洗浄方法が正常に作成されました！',
}
